import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { Toaster } from "sonner";
import { msalInstance } from "./lib/msalConfig";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Submit from "./pages/Submit";
import SubmissionSuccess from "./pages/SubmissionSuccess";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Vote from "./pages/Vote";
import AdminDashboard from "./pages/AdminDashboard";
import AdminVoting from "./pages/AdminVoting";
import AdminTeam from "./pages/AdminTeam";

function App() {
    return (
        <div className="App">
            <MsalProvider instance={msalInstance}>
                <AuthProvider>
                    <BrowserRouter>
                        <Toaster
                            position="top-center"
                            toastOptions={{
                                style: {
                                    background: "#FFFFFF",
                                    color: "#1F1A14",
                                    border: "1px solid #F1E6D2",
                                    fontFamily: "Manrope, sans-serif",
                                },
                            }}
                        />
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/submit" element={<Submit />} />
                            <Route path="/submit/success" element={<SubmissionSuccess />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route
                                path="/vote"
                                element={
                                    <ProtectedRoute>
                                        <Vote />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/voting"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminVoting />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/team"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <AdminTeam />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                </AuthProvider>
            </MsalProvider>
        </div>
    );
}

export default App;
